// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-189d126e]{font-size:14px;padding-left:20px}.download[data-v-189d126e]{margin-left:40px!important}.wrapper[data-v-189d126e]{padding-left:10px;padding-top:10px;word-break:break-all;font-family:Microsoft Yahei;float:left;width:400px}", ""]);
// Exports
module.exports = exports;
